<template>
  <div v-if="template === ProductTemplateType.CARD && product?.product_id" class="catalog__item order__item" itemscope itemtype="https://schema.org/Product">
    <div class="order__img-block" :class="{ active: cart !== null }" @click="showProductModalIfSippingIsset(product)">
      <div class="order__img" >
        <TheProductImage :product="product" :size="imageSize || ProductImageType.LARGE"/>
      </div>
      <OnlyOnClient>
        <TheProductTags :product="product"/>
      </OnlyOnClient>
      <div v-if="type === ProductType.DEFAULT" class="order__quantity" v-text="cart?.quantity" />
      <div v-else class="order__quantity" v-if="cart?.quantity">
        {{ totalQuantityByProductId }}
      </div>
    </div>
    <div class="order__info">
      <div class="order__info-top">
        <div itemprop="name" class="order__info-title" @click="showProductModalIfSippingIsset(product)">{{ product.name }}</div>
        <meta itemprop="description" :content="product.description">
        <div class="order__info-weight" style="margin-bottom: 5px" v-if="product.nutrition?.weight_formatted">{{ product.nutrition.weight_formatted }} </div>
      </div>
      <TheProductPlusAndMinusBox v-if="type === ProductType.DEFAULT" :product="product" v-model:cart="cart"/>
      <TheProductSelectButton v-else :product="product" v-model:cart="cart"/>
    </div>
  </div>
  <div v-if="template === ProductTemplateType.SLIDER" class="swiper-slide order__item">
    <div class="order__img-block" :class="{ active: cart !== null }">
      <div class="order__img" @click="showProductModalIfSippingIsset(product)">
        <TheProductImage  itemprop="image"  :product="product" :size="imageSize || ProductImageType.SMALL"/>
      </div>
     <OnlyOnClient>
       <TheProductTags :product="product"/>
     </OnlyOnClient>
      <div v-if="type === ProductType.DEFAULT" class="order__quantity" v-text="cart?.quantity" />
      <div v-else class="order__quantity">
        {{ totalQuantityByProductId }}
      </div>
    </div>
    <div class="order__info">
      <div class="order__info-title" @click="showProductModalIfSippingIsset(product)">{{ product.name }}</div>
      <div class="order__price-block" v-if="product.inSpotList">
       недоступно
      </div>
      <TheProductPlusAndMinusBox v-else-if="type === ProductType.DEFAULT" :product="product" v-model:cart="cart"/>
      <TheProductSelectButton v-else  :product="product" v-model:cart="cart" @click="showProductModalIfSippingIsset(product)"/>
    </div>
  </div>
</template>

<script>
import ProductType from "@/enum/ProductType.js";
import TheProductImage from "@/components/element/TheProductImage.vue";
import TheProductPlusAndMinusBox from "@/components/element/TheProductPlusAndMinusBox.vue";
import ProductImageType from "@/enum/ProductImageType.js";
import ProductTemplateType from "@/enum/ProductTemplateType.js";
import TheProductTags from "@/components/element/TheProductTags.vue";
import TheProductSelectButton from "@/components/element/TheProductSelectButton.vue";
import {mapMutations, mapState} from "vuex";
import OnlyOnClient from "@/components/OnlyOnClient.vue";
export default {
  name: 'TheProduct',
  components: {OnlyOnClient, TheProductSelectButton, TheProductTags, TheProductPlusAndMinusBox, TheProductImage},
  data() {
    return {
      cart: null,
      type: null
    }
  },
  mounted() {
    this.cart = this.cartFromStore;
  },
  created() {
    this.detectProductType();
  },
  watch:{
    'cartFromStore'(value){
      this.cart = value;
    }
  },
  computed: {
    ...mapState({
      'sipping' : state => state.shipping.shipping
    }),
    ProductTemplateType() {
      return ProductTemplateType
    },
    ProductImageType() {
      return ProductImageType
    },
    cartFromStore() {
      return this.$store.getters['cart/getProduct'](this.product.product_id)??null;
    },
    totalQuantityByProductId() {
      let total = 0;
      let products = this.$store.getters['cart/getAlProductInCart'](this.product.product_id);
      products.forEach(product => {
        total += parseInt(product.quantity);
      });
      return total;
    },
    ProductType() {
      return ProductType
    },
  },
  props: {
    product: {
      type: Object,
      require: true,
    },
    template: {
      default: ProductTemplateType.CARD
    },
    imageSize: {
      default: undefined
    }
  },
  methods:{
    ...mapMutations({
      'showProductModal': 'productModal/showProductModal',
      'setShowModal': 'shipping/setShowModal',
    }),
    showProductModalIfSippingIsset(product){
      this.showProductModal(product)

    },
    detectProductType(){
      if(this.product?.options !== undefined && this.product.options.length === 0){
        this.type = ProductType.DEFAULT
      }else if(this.product?.options !== undefined && this.product.options.length > 0){
        this.type = ProductType.COMPONENT
      }else if(this.product.constructor === true){
        this.type = ProductType.CONSTRUCTOR
      }
    }
  }
}
</script>